import React from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Grid from "@mui/material/Grid";

const TableEmptyComponent = () => {
  return (
    <TableRow>
      <TableCell colSpan={7}>
        <Grid
          container
          style={{ fontWeight: "bold" }}
          direction="row"
          justifyContent="center"
        >
          ไม่พบข้อมูล
        </Grid>
      </TableCell>
    </TableRow>
  );
};

export default TableEmptyComponent;
